export default function deserializeHash(query: string) {
    let match: any,
        pl = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=([^&]*)/g,
        decode = function (s: any) {
            return decodeURIComponent(s.replace(pl, ' '));
        },
        obj: any = {};
    match = search.exec(query);

    while (match) {
        obj[decode(match[1])] = decode(match[2]);
        match = search.exec(query);
    }

    return obj;
}